import type { ReferenceShot } from '@reelplicate/api-client/model';

/** The reference look's shots, in order (Figma 435:3338). */
export const SHOTS: { shot: ReferenceShot; title: string; hint: string }[] = [
  { shot: 'FACE', title: 'Face', hint: 'Front on, looking at the camera' },
  { shot: 'PROFILE', title: 'Profile', hint: 'Side on, left or right' },
  { shot: 'BACK', title: 'Back', hint: 'From behind, hair in view' },
  { shot: 'HALF_BODY', title: 'Hip to head', hint: 'Waist up, arms relaxed' },
  { shot: 'FULL_BODY', title: 'Head to toe', hint: 'Full body, standing' },
];
